import React, { ReactNode, createContext, useEffect, useState } from "react";

export type ModalIds =
  "wallet" |
  "property" |
  "stat" |
  "transaction" |
  "register" |
  "manage-token" |
  "chains" |
  "tx-shares" |
  "mint-shares" |
  "prices" |
  undefined

type ModalContextProps = {
  showModal: boolean,
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>,
  modalId: ModalIds,
  setModalId: React.Dispatch<React.SetStateAction<ModalIds>>,
  data: any,
  setData: React.Dispatch<React.SetStateAction<any>>
}

export const ModalContext = createContext<ModalContextProps>({
  showModal: false,
  setShowModal: () => { },
  modalId: undefined,
  setModalId: () => { },
  data: undefined,
  setData: () => { }
});

export const ModalContextProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [showModal, setShowModal] = useState(false);
  const [modalId, setModalId] = useState<ModalIds>();
  const [data, setData] = useState<any>()

  return (
    <ModalContext.Provider
      value={{
        showModal,
        setShowModal,
        modalId,
        setModalId,
        data,
        setData
      }}
    >
      {children}
    </ModalContext.Provider>
  );
}